<template>
  <div
    v-if="componentsShow"
    :id="data.id"
    class="zeus-component"
    :style="getCompStyles(data)"
    :is-editing="false"
    @click.passive="click"
  >
    <component
      :is="_curComponent"
      v-if="$root.componentsLoaded && _curComponent"
      ref="cpt"
      :editable-data="data"
      :is-flow="isFlow"
      @trackLog="handlerChildTrackLog"
      @dispatchEvent="dispatchEvent"
      @hook:mounted="getDom"
      @hook:beforeDestroy="beforeDestroy"
    />
  </div>
</template>

  <script>

  import { renderBg } from '@/utils/tools'
  import { BsGetCid } from 'dida-web-common'
  export default {
      'props': {
          'data': { 'type': Object },
          'page': { 'type': Object },
          'isFixedParent': { 'type': Boolean },
          'siteData': {
              'type': Object,
              'default': () => ({})
          }
      },
      'computed': {
          co() {
              return window
          },
          _curComponent() {
              if (window.ENV) {
                  var cut = window[this.data.type] || this.$root.componentsMap[this.data.type]
                  return cut && cut.default
              }
              return this.data.type
          },
          layoutType() {
              return this.page?.options?.basic?.layoutType
          },
          isFixed() {
              return this.layoutType === 'fixed'
          },
          isFlow() {
              return this.layoutType === 'static'
          },
          siteDataOptions() {
              return this.siteData.options
          }
      },
      'inject': ['globalConfig'],
      data() {
          return {
              '$animations': [],
              'childLoad': false,
              'headerList': [],
              'oneventList': [],
              'eventKey': [],
              'componentsShow': this.data.show,
              'click': () => {}
          }
      },
      'methods': {
          getDom() {
              while (this.headerList.length > 0) {
                  const ev = this.headerList.pop()
                  this.emitall(ev, this.$root.emitList[ev])
              }
              while (this.oneventList.length > 0) {
                  var { handler, action, params, triggerParams } = this.oneventList.pop()
                  handler(action, triggerParams, params)
              }
          },
          getCompStyles({ style, 'basic': cBase = {}}) {
              const {
                  border = {},
                  padding = {},
                  margin = {},
                  rect = {},
                  shadow = {},
                  background = {}
              } = style
              const unsetHeight = !this.globalConfig.editing && this.isFlow

              return {
                  'position': this.isFlow ? 'static' : (this.isFixedParent ? 'fixed' : 'absolute'),
                  'width': this.isFlow ? (this.getFlowWidth(margin) + this.globalConfig.unit) : this.handlerUnit(rect.w),
                  'height': unsetHeight ? 'auto' : this.handlerUnit(rect.h, rect.fs),
                  'border': `${this.handlerUnit(border.width)} ${border.style} ${border.color}`,
                  'borderRadius': this.getAngleVal(border.radius),
                  'overflow': cBase._overflow || 'hidden',
                  'padding': this.getAngleVal(padding),
                  'margin': this.getAngleVal(margin),
                  'boxShadow': `${this.handlerUnit(shadow.x)} ${this.handlerUnit(shadow.y)} ${this.handlerUnit(shadow.blur)} ${this.handlerUnit(shadow.spread)} ${shadow.color} ${shadow.inset === 'outset' ? '' : '"inset"' }`,
                  ...renderBg(background, this.$root.isSuWebp),
                  ...this.getCoordinate(rect),
                  'opacity': rect.a
              }
          },
          handlerUnit(v = 0, fs = false) {
              if (fs) {
                  return '100%'
              }
              return isNaN(Number(v)) ? v : (v + this.globalConfig.unit)
          },
          getFlowWidth(margin) {
              return (this.siteDataOptions.style?.rect?.width || 5) -
              (margin.left || 0) -
              (margin.right || 0)
          },
          getAngleVal({ top = 0, right = 0, bottom = 0, left = 0 } = {}) {
              return `${this.handlerUnit(top)} ${this.handlerUnit(right)} ${this.handlerUnit(bottom)} ${this.handlerUnit(left)}`
          },
          getCoordinate(rect) {
              const temp1 = { 'left': this.handlerUnit(rect.x), 'top': this.handlerUnit(rect.y) }
              return (window.$isEditing || !this.isFixed) ? temp1 : {
                  'left': this.getLocation(rect.l),
                  'right': this.getLocation(rect.r),
                  'top': this.getLocation(rect.t),
                  'bottom': this.getLocation(rect.b)
              }
          },
          getLocation(v) {
              return v === undefined ? 'auto' : this.handlerUnit(v)
          },
          handlerClick() {
            let oldtime = Date.now()
            let flag = true
            return () => {
                const newtime = Date.now()
                if (newtime - oldtime >= 1500) {
                    oldtime = Date.now()
                    flag = true
                }
                flag && this.clickText()
                flag = false
            }
          },
          async clickText() {
                if (this.data.type === 'mars-text') {
                    const goLogin = this.data.basic?.goLogin
                    if (goLogin === 1) {
                        return this.dispatchEvent('$e_click')
                    }
                    const { cid, access_token } = await BsGetCid()

                    if (!cid || !access_token) {
                        if (goLogin === 2) {
                            return this.$Login()
                        } else if (goLogin === 3) {
                            this.$Login()
                            let cb = () => {
                                this.dispatchEvent('$e_click')
                                cb = () => {}
                            }
                            this.$bus.$on('logined', cb)
                            return
                        }
                    } else {
                        return this.dispatchEvent('$e_click')
                    }
                } else {
                    return this.dispatchEvent('$e_click')
                }
          },
          dispatchEvent(ev) {
              const evid = `${this.data.id}-${ev}`
              if (this.data.type !== 'hermes-jscode' || ev === '$e_click') {
                this.$track.addStat(`${this.data.basic.COLOGID}-${ev}`)
              }
              if (this.$refs.cpt) {
                  this.emitall(evid)
              } else {
                  this.headerList.push(evid)
              }
          },
          emitall(evId, cpt) {
              cpt = cpt || { 'ctx': this.$refs.cpt }
              this.$bus.$emit(evId, cpt)
              if (evId.indexOf('$e_click') === -1) {
                  this.$root.emitList[evId] = cpt
                  if (this.eventKey.indexOf(evId) === -1) {
                    this.eventKey.push(evId)
                  }
              }
          },
          beforeDestroy() {
            this.eventKey.forEach(evId => {
                delete this.$root.emitList[evId]
            })
            this.eventKey = []
          },
          handlerChildTrackLog(ext, type = 'CLICK') {
              this.log(type, ext)
          },
          log(ext) {
              const operId = this.data.basic?.COLOGID
              operId && this.$track && this.$track.addStat(operId || ext)
          },
          initEvent() {
              if (!this.data.action || !this.data.action.length) {
                  return
              }

              const handler = ({ handler, 'options': { data } = { 'data': '' }}, { ctx }, params) => {
                  switch (handler) {
                  case '$h_hide':
                        this.componentsShow = false
                      break
                  case '$h_show':
                        this.componentsShow = true
                      break
                  case '$h_tel':
                      location.href = `tel:${data || params.tel?.value}`
                      break
                  case '$h_link':
                        this.parseUrl(data || params.link?.value)
                      break
                  case '$h_anchor':
                      this.$refs.cpt.$el.scrollIntoView({ behavior: 'smooth', block: 'start' })
                      break
                  // case '$h_callup':
                  //     window.SMART?.Callup?.call({
                  //         linkUrl: params.linkUrl?.value,
                  //         hideTitle: params.hideTitle?.value,
                  //     });
                  //     break
                  default:
                      // eslint-disable-next-line no-case-declarations
                      const realParams = {}
                      Object.keys(params).forEach((key) => {
                          realParams[key] = params[key].type === 'dynamic' ? ctx[params[key].value] : params[key].value
                      })
                      this.$refs.cpt && this.$refs.cpt[handler](realParams)
                  }
              }

              // const beforeSubscribe = (subscribe, action) => {
              //     switch (action.handler) {
              //         case '$h_callup':
              //             // 初始化需要dom selector，subscribe为编辑平台dom id + event的拼接
              //             // 去掉后缀获得dom id
              //             const EVENT_SUFFIX = '-$e_click';
              //             subscribe &&
              //                 window.SMART?.Callup?.init('#' + subscribe.replace(EVENT_SUFFIX, ''));
              //             break;
              //         default:
              //             // 其他处理...
              //             break;
              //     }
              // }

              this.data.action.forEach((action) => {
                const { params } = action
                  action.subscribe && action.subscribe.forEach((subscribe) => {
                    const paramsAll = (action.newParams && action.newParams[subscribe]) || params
                      if (this.$root.emitList[subscribe]?.ctx) {
                        if (action.handler === '$h_show' || this.$refs?.cpt) {
                            handler(action, this.$root.emitList[subscribe], paramsAll)
                        } else {
                            this.oneventList.push({
                                  handler,
                                  action,
                                  triggerParams: this.$root.emitList[subscribe],
                                  params: paramsAll
                              })
                        }
                      }
                      this.$bus.$on(subscribe, (triggerParams) => {
                          if (!this.$refs?.cpt && action.handler !== '$h_show') {
                              this.oneventList.push({
                                  handler,
                                  action,
                                  triggerParams,
                                  params: paramsAll
                              })
                          } else {
                              handler(action, triggerParams, paramsAll)
                          }
                      })
                  })
              })
          },
          initAnimation() {
              this.$refs.cpt?.$on('Animation:play', () => {
                  this.$animations.forEach(animation => animation?.play())
              })
              this.$refs.cpt?.$on('Animation:pause', () => {
                  this.$animations.forEach(animation => animation?.pause())
              })

              let animationCount = 0
              const { animation: animations = [] } = this.data

              this.$animations = animations.map(({ immediate = true, keyframes, iterations, ...options }, index) => {
                  const animation = this.$refs.cpt?.$el.animate?.(keyframes, {
                      ...options,
                      iterations: +iterations
                  })
                  !immediate && animation?.pause()

                  animation && (animation.onfinish = (ae) => {
                      this.$refs.cpt.$emit(`Animation:finished:${index}`, ae)
                      if (ae.target.id) {
                          this.$refs.cpt.$emit(`Animation:finished:${ae.target.id}`, ae)
                      }

                      animationCount++
                      if (animationCount === animations.length) {
                          // 重置animationCount
                          animationCount = 0
                          this.$refs.cpt.$emit('Animation:finished', ae)
                      }
                  })

                  return animation
              })

              // NOTE: 暴漏$animation到组件
              this.data.$animation = this.$animations
          },
          watchComponent() {
              // this.$refs.cpt 不存在！！！
              let $component
              const vm = this
              Object.defineProperty(this.$refs, 'cpt', {
                  get() {
                      return $component
                  },
                  set(value) {
                      $component = value
                      value && vm.initAnimation()
                  },
                  'enumerable': true,
                  'configurable': true
              })
          },
          async parseUrl(url) {
            var parser = document.createElement('a')
            parser.href = url
            if (parser.hostname.indexOf('.didachuxing.com') === -1) {
                location.href = url
                return
            }
            let search = parser.search
            const { cid, access_token } = await BsGetCid()
            const user = `cid=${cid}&access_token=${access_token}`
            search ? search += (`&${user}`) : search += (`?${user}`)
            location.href = parser.origin + parser.pathname + search
          }
      },
      watch: {
          '$root.componentsLoaded': {
              handler(value) {
                  value && this.$nextTick(() => {
                      if (this.$refs.cpt) {
                          // this.$refs.cpt 存在
                          this.initAnimation()
                          return
                      }
                      this.watchComponent()
                  })
              },
              immediate: true
          }
      },
      mounted() {
          this.initEvent()
          this.click = this.handlerClick()
      }
  }
  </script>

  <style>

  </style>

